// import { loginApi, menuApi } from '@/api'
import router from '@/router/router'
export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {


  }
}